export default __webpack_public_path__ + "static/media/offer_agreement_draft.a7ab22d0.pdf";